module.exports = __webpack_public_path__ + "static/media/temp_12.6240b5e3.jpg";